<script setup lang="ts">
import { useAttrs } from 'vue';

defineOptions({ inheritAttrs: false, name: 'EGS_ToggleSwitch' });
const props = withDefaults(defineProps<{ modelValue?: boolean; disabled?: boolean; inputId?: string; name?: string }>(), { modelValue: false, disabled: false });
const emit = defineEmits<{ 'update:modelValue': [value: boolean]; change: [event: { value: boolean }] }>();
const attrs = useAttrs();

function toggle() {
	if (props.disabled) return;
	const value = !props.modelValue;
	emit('update:modelValue', value);
	emit('change', { value });
}
</script>

<template>
	<button
		v-bind="{ ...attrs, ...(inputId ? { id: inputId } : {}), ...(name ? { name } : {}) }"
		type="button"
		role="switch"
		:aria-checked="modelValue"
		:disabled="disabled"
		:class="[
			'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 disabled:cursor-not-allowed disabled:opacity-60',
			modelValue ? 'bg-emerald-600' : 'bg-surface-300 dark:bg-surface-600',
			attrs['class']
		]"
		@click="toggle"
	>
		<span :class="['inline-block h-5 w-5 rounded-full bg-white shadow transition-transform', modelValue ? 'translate-x-5' : 'translate-x-0.5']"></span>
	</button>
</template>
